import * as React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { BrokerItem } from '../ui/broker/Item';
import { H1 } from './HeaderTitle';
import { Line } from '../ui/divider/Line';
import { PageContentType } from '../../../server/global/enum';

//GraphQL
import { Query, QueryGetPageContentInputArgs } from '../../../client/types/generated/types';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';
import { useQuery } from '@apollo/client';
import { Employee, useDepartmentEmployeesQuery } from '../../__types__/generated/cluster';
import { env } from '../../__config__/env';
import { client } from '../../../client/__graphql__/clusterClient';

export const SectionBrokersStyle = styled.div`
  span {
    font-size: 16px;
  }
`;

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const BrokerInfo = styled.div`
  font-weight: 300;
  padding: 0 2em;

  p {
    text-align: unset;
  }

  @media all and (max-width: 630px) {
    padding: 0 1em;
  }
`;

export const SectionBrokers: React.FC<{ style?: any }> = ({ style }) => {
  const params = useParams<{ urltag: string }>();

  const { data: broker_data, loading: broker_loading } = useQuery<GetPageItem, QueryGetPageContentInputArgs>(CONTENT_ITEM, {
    skip: !params.urltag,
    fetchPolicy: 'network-only',
    variables: { input: { urltag: params.urltag, type: PageContentType.BROKER } }
  });

  const { data } = useDepartmentEmployeesQuery({
    fetchPolicy: 'network-only',
    client: client,
    variables: {
      input: {
        alias: params.urltag,
        brandId: env.BRAND_ID
      }
    }
  });

  return (
    <>
      {broker_data?.getNdPageContent?.title ? (
        <H1 style={style}>
          {broker_data?.getNdPageContent?.title}
          <Line
            style={{
              margin: '0 auto',
              marginTop: '20px',
              marginBottom: '31px'
            }}
          />
        </H1>
      ) : (
        <H1 style={style}>Våre meglere i {data?.department?.postalPlace}</H1>
      )}
      <BrokerInfo>
        <p
          dangerouslySetInnerHTML={{
            __html: broker_data?.getNdPageContent?.text ? broker_data?.getNdPageContent?.text : ''
          }}
        />
      </BrokerInfo>
      <SectionBrokersStyle>
        <BrokerWrapper>
          {data?.department?.employees &&
            data?.department?.employees.map((item: Partial<Employee>, index: any) => {
              return (
                <BrokerItem
                  key={`broker_${index}`}
                  name={item.name ?? ''}
                  title={item.title ?? ''}
                  office={data?.department?.name ?? ''}
                  phone={item.mobilePhone ?? ''}
                  path={`https://www.privatmegleren.no${item.links?.profile?.path}`}
                  image={item.image?.url ?? ''}
                />
              );
            })}
        </BrokerWrapper>
      </SectionBrokersStyle>
    </>
  );
};

const BrokerWrapper = styled.div`
  padding: 30px 0;
  display: grid;
  grid-template-columns: 200px 200px 200px;
  grid-column-gap: 20px;
  grid-row-gap: 14px;
  justify-content: center;
  margin-top: 4em;
  margin-bottom: 2.5em;

  @media all and (max-width: 790px) {
    grid-template-columns: 200px 200px;
  }
  @media all and (max-width: 620px) {
    grid-template-columns: 200px;
  }
`;
